<div class="header">
  <div>
    <h2>{{ "pages.knowledgeBase.title" | translate }}</h2>
  </div>

  <nb-select
    *ngIf="canFilterByUser && users.length"
    class="user-filter"
    [selected]="selectedUserFilter"
    (selectedChange)="onUserFilterChange($event)"
    [placeholder]="'pages.tutors.filter.userLabel' | translate"
    size="small"
    nbTooltip="{{ 'pages.tutors.filter.userFilterHint' | translate }}"
    nbTooltipPlacement="bottom"
  >
    <nb-option value="all">{{ 'pages.tutors.filter.allUsers' | translate }}</nb-option>
    <nb-option *ngFor="let u of users" [value]="u.id">{{ u.name }}</nb-option>
  </nb-select>
  <!-- Woher das Kurswissen kommt (Platzierungen) und wofür diese Seite da
       ist (weitere Dokumente, Ordner). Ohne Platzierungen im Menü nur der
       zweite Teil — siehe hasPlacements. -->
  <app-page-help
    ><ng-container *ngIf="hasPlacements; else documentsOnly"
        >{{ "pages.knowledgeBase.intro.coursesBefore" | translate
        }}<a routerLink="/tutors/placements">{{ "pages.tutors.menu.placements" | translate }}</a
        >{{ "pages.knowledgeBase.intro.coursesAfter" | translate }}<br />{{
          "pages.knowledgeBase.intro.documents" | translate
        }}</ng-container
      >
    <ng-template #documentsOnly>{{ "pages.knowledgeBase.intro.documentsOnly" | translate }}</ng-template></app-page-help
  >
</div>

<div class="grid">
  <nb-card size="small" class="bucket-card" alAnchor="knowledge.bucket-list">
    <div class="panel-search">
      <app-search-input
        [(value)]="searchText"
        (valueChange)="onSearchChange()"
      ></app-search-input>
      <button
        nbButton
        status="primary"
        (click)="onAdd()"
        alAnchor="knowledge.create-bucket"
        alNotes="addKnowledgeBaseButton"
        [alNotesIsVisible]="!selectedBucket && !bucketService.loading$.value"
      >
        <nb-icon icon="plus"></nb-icon>
      </button>
    </div>
    <div class="bucket-list-scroll">
      <!-- Ohne Trennlinien (`al-list--plain`): die Ordner-Plaketten geben
           jeder Zeile den Takt — design.md §4b „Wissensbasis-Ordnerliste". -->
      <nb-list class="al-list--plain">
        <nb-list-item
          *ngFor="let b of pagedBuckets"
          [agentTarget]="['bucket', b.id, 'row']"
          (click)="onSelect(b)"
          [ngClass]="{ selected: b.id === selectedBucket?.id }"
          [attr.aria-current]="b.id === selectedBucket?.id ? 'true' : null"
          appMarqueeOnHover
          [nbTooltip]="b.description || (b.lms_source ? ('pages.knowledgeBase.syncFolderDescription.' + b.lms_source | translate) : '')"
          [nbTooltipDisabled]="!b.description && !b.lms_source"
          nbTooltipPlacement="right"
        >
          <div class="folder">
            <!-- CI-Plakette (design/portal-ci): geschlossener Ordner, in der
                 gewählten Zeile der offene — wie in wissensbasis-vorschau.html.
                 Immer genau EINE der beiden Klassen: `--folder` steht in
                 alphalearn-symbols.css hinter `--folder-open` und gewönne sonst. -->
            <span
              class="al-relief-icon"
              [class.al-icon--folder-open]="b.id === selectedBucket?.id"
              [class.al-icon--folder]="b.id !== selectedBucket?.id"
              aria-hidden="true"
            ><span class="al-relief-glyph"></span></span>
            <!-- Nur der Name, einzeilig — alle Zeilen gleich hoch. Die
                 Beschreibung steht im Tooltip der Zeile, lange Namen laufen
                 bei Mouseover durch (appMarqueeOnHover). -->
            <div class="labels">
              <p class="name marquee">{{ b.name }}</p>
            </div>

            <div class="actions">
              <button nbButton ghost status="primary" (click)="onAdd(b)">
                <nb-icon icon="edit"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="danger"
                (click)="onDelete(b, $event)"
              >
                <nb-icon icon="trash"></nb-icon>
              </button>
            </div>
          </div>
        </nb-list-item>
      </nb-list>
    </div>

    <div class="bucket-pagination-bar" *ngIf="displayedBuckets.length > bucketPageSize">
      <app-pagination
        class="toolbar-pagination"
        [totalItems]="displayedBuckets.length"
        [itemsPerPage]="bucketPageSize"
        [currentPage]="bucketPage"
        [pageSizeOptions]="bucketPageSizeOptions"
        (pageChanged)="onBucketPageChange($event)"
        (itemsPerPageChange)="onBucketPageSizeChange($event)"
      ></app-pagination>
    </div>
  </nb-card>
  <nb-card size="small" alAnchor="knowledge.bucket-content">
    <div class="panel-search" *ngIf="selectedBucket">
      <app-search-input [(value)]="rightSearchText"></app-search-input>
    </div>
    <nb-tabset (changeTab)="onChangeTab($event)" *ngIf="selectedBucket">
      <!-- chat styling -->
      <nb-tab tabId="files" tabTitle="{{ 'pages.knowledgeBase.tabFiles' | translate }}">
        <app-files-table
          bucketId="{{ selectedBucket?.id }}"
          title="{{ currentTab }} in {{ selectedBucket?.name }}"
          [loading]="loading"
          [searchText]="rightSearchText"
        ></app-files-table>
      </nb-tab>
      <nb-tab tabId="websites" tabTitle="{{ 'pages.knowledgeBase.tabWebsites' | translate }}">
        <app-website-table
          bucketId="{{ selectedBucket?.id }}"
          title="{{ currentTab }} in {{ selectedBucket?.name }}"
          [loading]="loading"
          [searchText]="rightSearchText"
        ></app-website-table>
      </nb-tab>
      <nb-tab tabId="courses" tabTitle="{{ 'pages.knowledgeBase.tabCourses' | translate }}">
        <app-courses-table
          bucketId="{{ selectedBucket?.id }}"
          title="{{ currentTab }} in {{ selectedBucket?.name }}"
          [loading]="loading"
          [searchText]="rightSearchText"
        ></app-courses-table>
      </nb-tab>
      <!-- Creator-Inhalte (creator-items.md): nur, wenn der Bucket welche hat -->
      <nb-tab
        *ngIf="(bucketService._creatorItems | async)?.length"
        tabTitle="{{ 'pages.knowledgeBase.tabCreator' | translate }}"
      >
        <app-creator-items-table
          bucketId="{{ selectedBucket?.id }}"
          title="{{ currentTab }} in {{ selectedBucket?.name }}"
          [loading]="loading"
          [searchText]="rightSearchText"
        ></app-creator-items-table>
      </nb-tab>
    </nb-tabset>
  </nb-card>
</div>
